import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-privacy-garante-detenuti-modal',
    templateUrl: './privacy-garante-detenuti-modal.component.html',
    styleUrls: ['./privacy-garante-detenuti-modal.component.scss']
})
export class PrivacyGaranteDetenutiModalComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<PrivacyGaranteDetenutiModalComponent>) { }

    ngOnInit() {
    }

}
